import {
	getCurrentQuarter,
	getStartQuarterDate,
	getToday,
} from "components/Shared/MultiRangeCalendar/CalendarPresets/utils/utils"
import { addDays, subDays } from "date-fns"

export const calculateStartOfQuarter = () => {
	const currentQuarter = getCurrentQuarter()

	const currentQuarterFirstMonth = getStartQuarterDate(currentQuarter)

	return new Date(getToday().getFullYear(), currentQuarterFirstMonth)
}

export const calculateStartOfMonth = () =>
	new Date(getToday().getFullYear(), getToday().getMonth(), 1)

export const getEndDateWithData = () => {
	const date = addDays(new Date(), -3)
	date.setHours(0)
	date.setMinutes(0)
	date.setSeconds(0)
	date.setMilliseconds(0)

	return date
}

export const calculateRangeLast90Days = () => {
	const endDate = getToday()
	const startDate = subDays(endDate, 90)

	return [startDate, endDate]
}

export const calculateRangeLast30Days = () => {
	const endDate = getToday()
	const startDate = subDays(endDate, 30)

	return [startDate, endDate]
}

export const getCalendarLabel = (presetId: string) =>
	`phronesis.rangecalendar.defaultpreset.single.${presetId}`
